<template>
  <div class="profile-wapper-container">
    <div class="left">
      <h1>{{ $t("home.companyProfile.h1") }}</h1>
      <p class="company-text">&emsp;&emsp;{{ $t("home.companyProfile.p1") }}</p>
      <h2>{{ $t("home.companyProfile.h2") }}</h2>
      <ul>
        <li>{{ $t("home.companyProfile.list.first") }}</li>
        <li>{{ $t("home.companyProfile.list.second") }}</li>
        <li>{{ $t("home.companyProfile.list.third") }}</li>
        <li>{{ $t("home.companyProfile.list.fourth") }}</li>
      </ul>

      <!-- 模拟按钮 -->
      <button class="jump-button" @click="$router.push('/about')">{{$t('home.companyProfile.more-button')}}</button>
    </div>
    <div class="right">
      <img src="../../../assets/images/home/index-car01.webp" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.profile-wapper-container {
  padding: 48px;
  display: flex;
  justify-content: center;
  align-items: center;

  .left {
    margin-right: 120px;
    width: 60%;
    h1 {
      color: #ff5d1b;
    }
    h2 {
      color: #ff5d1b;
    }
    ul {
      margin-left: 20px;
      font-size: 13px;
      color: #40404a;
      line-height: 24px;
      list-style-type: circle;
      padding: 0;


    }
    .company-text {
      font-size: 13px;
      color: #40404a;
      line-height: 24px;
    }

    .jump-button{
      margin: 12px 0 0 0;
      padding: 10px 36px;
      box-sizing: border-box;
      border-radius: 3px;
      border: none;
      background-color: #ff5d1b;
      color: #fff;
      cursor: pointer;
      transition-duration: 0.4s;
    }
    .jump-button:hover{
      opacity: 0.8;
      
    }
  }

  .right{
    width: 40%;
    img{
      width: 100%;
    }
  }
}
</style>